import RequirementFull from 'features/requirements/dtos/RequirementFullDTO';
import Alert from 'features/shared/alerts/components/Alert';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './confirmmobilealert.module.scss';

interface Props {
  requirement: RequirementFull;
  setConfirmMobileDialogShow: React.Dispatch<React.SetStateAction<boolean>>;
}

const ConfirmMobileAlert = ({ requirement, setConfirmMobileDialogShow }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  if (
    requirement.requirementType?.code === "ZMENA_MOBIL_TELEFONU" &&
    (requirement.actualState?.code === "CEKANI_NA_OVERENI" || 
    requirement.actualState?.code === "OdeslaniOverovaciZpravy")
  ) {
    return (
      <Alert alertObj={{ alertType: "Info" }} >
        <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
          <span className="mr-2 mb-2 mb-sm-0">
            {tLabels("confirmMobileAlert.message")}
          </span>
          <button className={`btn btn-sm btn-secondary ${styles.confirmButton}`} onClick={() => setConfirmMobileDialogShow(true)}>
            {tLabels("confirmMobileAlert.setVerificationCode")}
          </button>
        </div>
      </Alert>
    );
  } else {
    return null;
  }
}

export default ConfirmMobileAlert;
